import { Box, Fade, IconButton, ITheme, Popper, PopperPlacementType, SvgIcon, Tooltip, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { ReactComponent as AiIcon } from '../../assets/ai_icon.svg';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { dismissAi } from '../../store/actions/createPortfolio';

interface ILeoAiOverlayProps {
    children: React.ReactNode;
    target: React.RefObject<HTMLDivElement>;
    orientation?: 'normal' | 'reverse';
    placement?: PopperPlacementType;
    alignItems?: 'flex-end' | 'flex-start'
    padding?: string;
    maxWidth?: string;
    delay?: number;
    undismissable?: boolean;
}

const LeoAiOverlay: React.FunctionComponent<ILeoAiOverlayProps> = ({ children, target, orientation, placement, alignItems, padding, maxWidth, delay, undismissable }) => {
    const theme = useTheme() as ITheme;
    const aiDismissed = useAppSelector(state => state.createPortfolio.aiDismissed);
    const dispatch = useAppDispatch();
    const [shown, setShown] = useState(!(delay !== undefined && delay > 0));
    // const [top, setTop] = useState(0);
    // const [left, setLeft] = useState(0);

    // const updatePosition = () => {
    //     if(target !== null && target.current !== null){
    //         setTop(target.current.offsetTop);
    //         setLeft(target.current.offsetLeft);
    //     }
    // }

    // useEffect(() => {
    //     updatePosition() ;
    // }, [target, target.current])
    useEffect(() => {
        if (delay && delay > 0) {
            setTimeout(() => {
                setShown(true);
            }, delay);
        }
    }, []);

    const onUndismiss = (ev:React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        ev.stopPropagation();
        dispatch(dismissAi(false));
    }
    const onDismiss = () => {
        dispatch(dismissAi(true));
    }

    return (
        <Popper open={true} anchorEl={target.current} popperOptions={{ placement: placement ? placement : 'top-end' }} >
            <Fade in={shown}>
                <Box display={"flex"} flexDirection={orientation === 'reverse' ? "column-reverse" : "column"} gap={"8px"} alignItems={alignItems ? alignItems : "flex-end"} padding={padding} maxWidth={maxWidth}>
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"} bgcolor={theme.palette.leo.primary.blue[50]} borderRadius={"50%"} width={"70px"} height={"70px"} boxShadow={"0px 12px 16px -4px #164CAE29"} sx={{ cursor: (aiDismissed ? "pointer" : undefined) }} onClick={onUndismiss} >
                        <SvgIcon component={AiIcon} inheritViewBox sx={{ width: "40px", height: "40px" }} />
                    </Box>
                    {(undismissable || !aiDismissed) && <Box bgcolor={theme.palette.leo.primary.blue[50]} color={theme.palette.primary.dark} fontWeight={"500"} borderRadius={"8px"} padding={"12px"} boxShadow={"0px 12px 16px -4px #164CAE29"} maxWidth={"220px"} fontSize={"12px"}>
                        {!undismissable && <Box sx={{ float: 'right'}}><IconButton size='small' onClick={onDismiss}><CloseIcon fontSize='small' /></IconButton></Box>}
                        {children}
                    </Box>}
                </Box>
            </Fade>
        </Popper>
    )
}

export default LeoAiOverlay